import { createRoutes } from 'shared/hocs'

import baseNavigation from './baseNavigation'
import deliveryNavigation from './deliveryNavigation'

export default createRoutes(
  () => [
    {
      path: '/app-testing',
      component: deliveryNavigation,
    },
    {
      path: '/',
      component: baseNavigation,
    },
  ],
  { switched: true }
)
